/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Image from "next/image";
import styles from "./emoji.module.css";
import cn from "classnames";
import React from "react";

const emojis = {
  brain: { path: "brain.png", height: 100, width: 100 },
  briefcase: { path: "briefcase.png", height: 100, width: 100 },
  community: { path: "community.png", height: 177, width: 249 },
  ninja: { path: "ninja.png", height: 100, width: 100 },
  crossMark: { path: "cross-mark.png", height: 100, width: 100 },
  checkMark: { path: "check-mark.png", height: 100, width: 100 },
  thugLife: { path: "thug-life.png", height: 196, width: 181 },
  dizzy: { path: "dizzy.png", height: 100, width: 100 },
  wizard: { path: "wizard.png", height: 100, width: 100 },
};

export type EmojiName = keyof typeof emojis;

interface Props {
  name: EmojiName;
  width?: string;
}

const Emoji = ({ name, width: customWidth }: Props) => {
  const style: React.CSSProperties = {};

  if (customWidth) {
    style.width = customWidth;
  }

  if (!emojis[name]) {
    return null;
  }

  const { path, height, width } = emojis[name];

  return (
    <div role="img" className={cn(customWidth && styles.main)} style={style}>
      <Image
        src={`/assets/emojis/${path}`}
        height={height}
        width={width}
        layout="responsive"
        priority
      />
    </div>
  );
};

export default Emoji;
